/* unplugin-vue-components disabled */import script from "./FloatingVideoBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingVideoBox.vue?vue&type=script&setup=true&lang=js"

import "./FloatingVideoBox.vue?vue&type=style&index=0&id=592e7779&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592e7779"]])

export default __exports__